define('views/address_book_export/Podio.Views.AddbookExport',['require','translate','lib/backbone/Backbone.PodioView','jst!address_book_export/_main','jst!address_book_export/_empty','jst!address_book_export/_matrix','jst!address_book_export/_list','jst!shared/generic_loader_small'],function(require) {

  var t = require('translate');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');

  var jstMain = require('jst!address_book_export/_main');
  var jstEmpty = require('jst!address_book_export/_empty');
  var jstMatrix = require('jst!address_book_export/_matrix');
  var jstList = require('jst!address_book_export/_list');
  var jstGenericLoaderSmall = require('jst!shared/generic_loader_small');

  return ViewPodioBase.extend({
    podioEvents: {
      'click .close-button': 'onCloseButtonClick',
      'click .connect-button': 'onConnectButtonClick',
      'click .add-button': 'onAddToAddressbookClick',
      'click .providers-container-trigger': 'toggleProvidersContainer'
    },

    initialize: function() {
      this.podioDelegateEvents();
      this.render();
      this.options.providersCol.bind('reset', this.renderProvidersList, this);
      this.options.accountsCol.bind('reset', this.renderAccountsList, this);
    },

    render: function() {
      this.elm.html(this.getTemplate(jstMain, {
        privateEmail: this.options.privateEmail,
        publicEmail: this.options.publicEmail,
        privateName: this.options.privateName,
        publicName: this.options.publicName,
        emailSettingsPath: this.options.emailSettingsPath,
        vCardPath: this.options.vCardPath
      }));
      this.elmProviders = this.elm.find('.providers');
      this.elmAccounts = this.elm.find('.accounts');
      this.elmProvidersVisibilityWrapper = this.elm.find('.providers-visibility-wrapper');
      this.elmProvidersContainerArrow = this.elm.find('.providers-container .arrow-icon');
    },

    renderProvidersList: function() {
      var self = this;

      if (this.options.providersCol.isEmpty()) {
        this.elmProviders.html(this.getTemplate(jstEmpty, {
          message: t('There are no providers available #addressbook-export')
        }));
        return true;
      }

      var col = this.options.providersCol.map(function(p) {
        return {
          label: self.formatProviderLabel(p.get('humanized_name')),
          name: p.get('name'),
          icon: self.formatProviderName(p.get('name'))
        };
      });
      this.elmProviders.html(this.getTemplate(jstMatrix, {
        providers: col,
        className: 'connect-button',
        idProperty: 'name'
      }));
    },

    renderAccountsList: function() {
      if (this.options.accountsCol.isEmpty()) {
        this.expandProvidersContainer();
        this.elm.find('.accounts-wrapper').empty();
        this.elm.find('.providers-container-trigger').remove();
        return true;
      }

      var col = this.options.accountsCol.map(function(p) {
        return {
          label: p.get('label'),
          icon: p.get('icon'),
          id: p.get('id')
        };
      });
      this.elmAccounts.html(this.getTemplate(jstList, {
        providers: col,
        buttonName: t('Add to this #addressbook-export'),
        buttonClass: 'add-button',
        idProperty: 'id'
      }));
    },

    renderAccountsSpinner: function() {
      this.elmAccounts.html(this.getTemplate(jstGenericLoaderSmall));
    },

    toggleProvidersContainer: function() {
      if (this.elmProvidersVisibilityWrapper.hasClass('hidden')) {
        this.expandProvidersContainer();
      } else {
        this.collapseProvidersContainer();
      }
    },

    expandProvidersContainer: function() {
      this.elmProvidersVisibilityWrapper.removeClass('hidden');
      this.elmProvidersContainerArrow.removeClass('icon-arrow-down-grey').addClass('icon-arrow-up-grey');
    },

    collapseProvidersContainer: function() {
      this.elmProvidersVisibilityWrapper.addClass('hidden');
      this.elmProvidersContainerArrow.removeClass('icon-arrow-up-grey').addClass('icon-arrow-down-grey');
    },

    onCloseButtonClick: function() {
      this.trigger('addbookExportMainView:closeButtonClicked');
    },

    formatProviderName: function(name) {
      var nameMap = {
        'live': 'hotmail'
      };
      return nameMap[name] ? nameMap[name] : name;
    },

    formatProviderLabel: function(label) {
      var labelMap = {
        'Microsoft': 'Office 365 Personal'
      };
      return labelMap[label] ? labelMap[label] : label;
    },

    onConnectButtonClick: function(elmTarget) {
      this.trigger('addbookExportMainView:connectAccountTriggered', elmTarget.data('id'));
    },

    onAddToAddressbookClick: function(elmTarget) {
      elmTarget.addClass('loader');
      this.trigger('addbookExportMainView:addToAddressbookTriggered', parseInt(elmTarget.data('id'), 10));
    },

    setDoneStateOnAccountButton: function(accountId) {
      var elmTarget = this.elmAccounts.find(".add-button[data-id='" + accountId + "']");

      elmTarget.removeClass('loader').addClass('added').text(t('Added #addressbook-export'));
      // insert the tick
      elmTarget.prepend('<span class="icon-16 icon-checkmark-black"></span>');
    },

    setFailedStateOnAccountButton: function(accountId) {
      var elmTarget = this.elmAccounts.find(".add-button[data-id='" + accountId + "']");
      elmTarget.removeClass('loader');
    }
  });

});

